module.exports = __webpack_public_path__ + "img/person2.f9b2302c.svg";